import { UtmSource } from '@packages/shared/core/user/entities';
import { removeQueryParams } from '@packages/shared/core/common/utils/url/removeQueryParams';
import { getOrganicChannel } from '@packages/shared/core/common/utils/channel/getOrganicChannel';
import { getBaseURL } from '@packages/shared/core/common/utils/browser/getBaseURL';
import { ChannelAttributionStrategy } from './ChannelAttributionStrategy';

export class OrganicChannelAttributionStrategy implements ChannelAttributionStrategy {
  private readonly referrer: string;

  constructor(referrer: string) {
    this.referrer = referrer;
  }

  getUtmTags() {
    return {
      utm_source: UtmSource.ORGANIC,
      seo_referrer: removeQueryParams(this.referrer),
      seo_landing_page: getBaseURL(),
      seo_channel: getOrganicChannel(this.referrer) ?? '',
    };
  }
}
